export enum DropzoneFileType {
  Image = 'image',
  File = 'file',
}
